import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'react-router-dom'

class Sidebar extends Component {

    constructor(props) {
        super(props)

        this.handlefiltercat = this.handlefiltercat.bind(this)
    }

    handlefiltercat(cat, url = '', param = '') {
        if(""!==cat) {
            this.props.history.push(url+param+cat)
        } else {
            this.props.history.push(url)
        }
        
        window.scrollTo(0, 0)
    }

    render() {

        const { 
            levelcat, category, category2, 
            category1list, category2list,
            urlparamsidebar, urlparamsidebar2 
        } = this.props
        const category1listlength = category1list.length

        if(""!==category){
            this.props.filterCat1(category)

            if(""!==category2){
                this.props.filterCat2(category2)
            } else {
                this.props.filterCat1(category)
            }

        } else {
            this.props.clearfilterCat()
        }

        var rendercatlist
        if("0"===levelcat) {
            if(1 < category1listlength){
                // list category 1
                rendercatlist = (
                    <>
                        <div key="0">
                            <span onClick={() => this.handlefiltercat('', urlparamsidebar)}>
                            {(""===category) ? <b>Semua Kategori</b> : 'Semua Kategori'}
                            </span>
                        </div>
                        {
                            category1list.sort((a,b) => a.CatName_1 > b.CatName_1).map(cat => {
                                return (
                                    <div key={cat.CatID_1}>
                                        <span onClick={() => this.handlefiltercat(cat.CatID_1, urlparamsidebar, '&category=')}>
                                            {(category===cat.CatID_1) ? <b>{ReactHtmlParser(cat.CatName_1)}</b> : ReactHtmlParser(cat.CatName_1)}
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </>
                )
            }
        } else if("1"===levelcat) {
            if(1 < category2list.length){
                    
                rendercatlist = (
                    <>
                        <div key="00">
                            <Link to={urlparamsidebar} onClick={() => this.props.refresh()}>Semua Kategori</Link>
                        </div>
                        <div key="0">
                            <span onClick={() => this.handlefiltercat('', urlparamsidebar2)}>
                            {(""===category2) ? <b>Semua Sub Kategori</b> : 'Semua Sub Kategori'}
                            </span>
                        </div>
                        {
                            category2list.sort((a,b) => a.CatName_2 > b.CatName_2).map(cat => {
                                return (
                                    <div key={cat.CatID_2}>
                                        <span onClick={() => this.handlefiltercat(cat.CatID_2, urlparamsidebar2, '&category2=')}>
                                            {(category2===cat.CatID_2) ? <b>{ReactHtmlParser(cat.CatName_2)}</b> : ReactHtmlParser(cat.CatName_2)}
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </>
                )
            }
        }

        return (
            <div className="sidebar">
                {rendercatlist}
            </div>
        )
        
    }
}

const mapStateToProps = (state) => ({
    category1list: state.ContentListReducer.category1list,
    category2list: state.ContentListReducer.category2list
})

const mapDispatchToProps = (dispatch) => ({
    clearfilterCat: () => dispatch({type:'CLEAR_FILTER_CAT'}),
    filterCat1: (category1) => dispatch({type:'FILTER_CAT1', category1}),
    filterCat2: (category2) => dispatch({type:'FILTER_CAT2', category2})
})

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)
